import { render, staticRenderFns } from "./data-policy.vue?vue&type=template&id=48ad5fbf"
import script from "./data-policy.vue?vue&type=script&lang=js"
export * from "./data-policy.vue?vue&type=script&lang=js"
import style0 from "./data-policy.vue?vue&type=style&index=0&id=48ad5fbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports